import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  logo: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "1.5rem",
    textTransform: "none",
    textDecoration: "none",
    color: "black",
  },
  navContainer: {
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
  },
  navLinks: {
    display: "flex",
    gap: "1.7rem",
    alignItems: "center",
    fontFamily:"'Josefin Sans',sans-serif",
    fontWeight: '600',
    "@media (max-width: 768px)": {
      display: "none", // Hide links on small screens
    },
  },
  navLink: {
    fontSize: "1rem",
    color: "black",
    textDecoration: "none",
    fontWeight: 600,
    position: "relative",
    fontFamily: "Poppins, sans-serif",
    "&:hover": {
      color: "black",
    },
  },
  drawerList: {
    width: 250,
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <>
      <AppBar
        position="absolute"
        color="transparent"
        elevation={0}
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          // borderBottom: '1px white solid'
        }}
      >
        <Toolbar>
          {/* Logo */}
          <Typography className={classes.logo} variant="h6" noWrap>
            <img src="/logo.png" alt="logo" style={{ width: "150px", height: "150px" }} />
          </Typography>

          {/* Navigation Links (Hidden on small screens) */}
          <Box className={classes.navContainer}>
            <Box className={classes.navLinks} component="nav">
              <a href="/" className={classes.navLink}>Home</a>
              <a href="/about-us" className={classes.navLink}>About Us</a>
              <a href="/" className={classes.navLink}>Contact</a>
            </Box>
          </Box>

          {/* Action Icons */}
          <Box display="flex" alignItems="center">
            <IconButton color="inherit">
              <SearchIcon style={{ fontSize: "35px" }} />
            </IconButton>

            {/* Menu Icon (Shown on Small Screens) */}
            {isMobile ? (
              <IconButton color="inherit" onClick={toggleDrawer(true)}>
                <MenuIcon style={{ fontSize: "35px" }} />
              </IconButton>
            ) : null}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile Navigation */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List className={classes.drawerList}>
          <ListItem button component="a" href="/" onClick={toggleDrawer(false)}>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button component="a" href="/about-us" onClick={toggleDrawer(false)}>
            <ListItemText primary="About Us" />
          </ListItem>
          <ListItem button component="a" href="/" onClick={toggleDrawer(false)}>
            <ListItemText primary="Contact" />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
